import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '@app/core/services/nav.service';
import { INavigationType } from '../../interfaces/navigation.interface';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  standalone: false,
})
export class SettingsComponent {
  // dependencies
  navService = inject(NavService);
  private _router = inject(Router);

  navigationConfig = signal<INavigationType[]>(
    this.navService.getSettingsNavigation(),
  );

  constructor() {}

  onBack(): void {
    this.navService.closeSettings();
    this.navService.closeMobileMenu();

    const lastRoute: string = this.navService.lastMainRoute();
    if (lastRoute) {
      this._router.navigate([lastRoute]);
    } else {
      this._router.navigate(['/account/dashboard']);
    }
  }
}
